import styled from '@emotion/styled';
import { Radio } from 'antd';
import { useTranslate } from '@tolgee/react';
import DecorateTitle from 'components/DecorateTitle';
import { QuickChatControl } from 'components/QuickChatControl';
import { DARK_MODE_ENABLED, useThemeContext } from 'components/ThemesProvider';
import SettingItemContainer from './SettingItemContainer';

const Wrapper = styled.div`
  display: flex;

  .ant-radio-group {
    display: inline-flex;
    border: 1px solid var(--fett-border-default);
    border-radius: 10px;
    overflow: hidden;
    background: var(--fett-bg-panel);
  }

  .ant-radio-button-wrapper {
    min-width: 108px;
    height: 40px;
    line-height: 38px;
    text-align: center;
    color: var(--fett-text-secondary);
    background: transparent;
    border-inline-start: 1px solid var(--fett-border-default);
    border-color: var(--fett-border-default);
  }

  .ant-radio-button-wrapper:first-child {
    border-inline-start: 0;
  }

  .ant-radio-button-wrapper:hover {
    color: var(--fett-app-primary-color);
  }

  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    color: var(--fett-app-primary-color);
    /* light 取品牌主色 tint（--ant-primary-1），与主色文字同族；
       dark 下 --ant-primary-1 被全局重映射为 --fett-bg-active，与原效果一致 */
    background: var(--ant-primary-1);
    border-color: var(--fett-border-default);
  }

  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before,
  .ant-radio-button-wrapper::before {
    background: var(--fett-border-default);
  }

  /* antd 对选中首钮单独把右边框设为 --ant-primary-5（主色），
     与本组件的中性边框设计冲突，收回到 border-default；
     选择器与 antd 同结构并多一层 Wrapper，确保优先级反超 */
  .ant-radio-button-wrapper-checked:not(
      .ant-radio-button-wrapper-disabled
    ).ant-radio-button-wrapper:first-child {
    border-right-color: var(--fett-border-default);
  }
`;

export const ColorModeSetting = () => {
  const { t } = useTranslate();
  const { resolvedMode, onColorModeChange } = useThemeContext();

  if (!DARK_MODE_ENABLED) {
    return null;
  }

  return (
    <QuickChatControl>
      <>
        <DecorateTitle>{t('app.config.colorMode.title')}</DecorateTitle>
        <SettingItemContainer>
          <Wrapper>
            <Radio.Group
              optionType="button"
              buttonStyle="solid"
              value={resolvedMode}
              onChange={(event) => onColorModeChange(event.target.value)}
            >
              <Radio.Button value="light">{t('app.config.colorMode.light')}</Radio.Button>
              <Radio.Button value="dark">{t('app.config.colorMode.dark')}</Radio.Button>
            </Radio.Group>
          </Wrapper>
        </SettingItemContainer>
      </>
    </QuickChatControl>
  );
};
